// extracted by mini-css-extract-plugin
export default {"label":"Select_label__E5dLb","select":"Select_select__rk4t-","subText":"Select_subText__b50hs"};